<template>
  <div id="app">
    <WelcomeScreen />
  </div>
</template>

<script>
import WelcomeScreen from './components/WelcomeScreen'

export default {
  name: 'app',
  components: {WelcomeScreen}
}
</script>

<style>
@import url('./assets/css/global.scss');
</style>
